var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      "fill-rule": "evenodd",
      d:
        "M89.392 1.416C78.967 1.23 30.051-3.989 14.661 9.552-.683 23.052-4.518 50.424 9.363 60.868c13.881 10.444 59.596 7.865 71.868 8.086 8.013.144 51.717-1.512 67.336-11.41 10.97-6.95 14.2-21.071 5.518-36.438-8.783-18.895-57.636-19.562-64.693-19.69z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11177a7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11177a7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_SVG/ShapeYearBtn4Tab.vue
// module id = 1z4K
// module chunks = 1